<script>
import _ from 'lodash'
import BaseSmartInput from './BaseSmartInput'
import LinkBuilding from '../features/link-building/LinkBuilding'
/**
 * child component of {@link BaseSmartInput}. is used in {@link LinkBuilding}
 */
export default {
  name: 'BaseSmartInputSearch',
  extends: BaseSmartInput,
  /**
   * next methods override corresponding parent methods
   */
  methods: {
    open () {
      this.$emit('state', 'open')
      this.isOpened = true
      this.filterOptions()
      this.setListStyle()
    },
    changeModel () {
      /* in this component we have simple structure of options: option.value === option.label */
      this.selectedOption.label = this.text
      this.selectedOption.value = this.text
      this.$emit('change', { value: this.text, text: this.text })
      this.$emit('apply')
    },
    select (option) {
      this.selectedOption = _.cloneDeep(option)
      this.text = this.selectedOption.label
      this.$emit('input-text', this.text)
      this.close()
    }
  }
}
</script>
